import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "blog" }
const _hoisted_2 = { class: "abc" }
const _hoisted_3 = { class: "sim-slider-container" }
const _hoisted_4 = { class: "barcont" }
const _hoisted_5 = { class: "bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Simulation = _resolveComponent("Simulation")!
  const _component_ic = _resolveComponent("ic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "section",
      style: _normalizeStyle({
        backgroundImage:
          `url(` +
          require(`@/assets/screenshots/${_ctx.simprojets[_ctx.currentIndex].screenshots![0]}`) +
          `)`,
      })
    }, null, 4),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", null, _toDisplayString(_ctx.$t('home.simulationsHeader')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "articles",
          style: _normalizeStyle({
            left: `-${_ctx.currentIndex * 1260}px`,
            '--idx': _ctx.currentIndex,
          })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simprojets, (sim) => {
            return (_openBlock(), _createBlock(_component_Simulation, {
              key: sim.title,
              sim: sim
            }, null, 8, ["sim"]))
          }), 128))
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "button left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.left()))
        }, [
          _createVNode(_component_ic, { icon: "angles-left" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.simprojets.length, (i) => {
            return (_openBlock(), _createBlock(_component_ic, {
              class: _normalizeClass(["dot", { active: i === _ctx.currentIndex + 1 }]),
              icon: "circle",
              key: i
            }, null, 8, ["class"]))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "button right",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.right()))
        }, [
          _createVNode(_component_ic, { icon: "angles-right" })
        ])
      ])
    ])
  ]))
}